import { Project } from '@/types';

export const mockProjects: Project[] = [
  {
    id: '1',
    name: 'Riverside Office Complex',
    description: 'A modern 12-story office building with sustainable features',
    client: 'Green Development Corp',
    referenceCode: 'ROC-2024-001',
    location: 'Manchester City Centre',
    status: 'active',
    currentStage: 2,
    startDate: new Date('2024-01-15'),
    targetCompletionDate: new Date('2025-06-30'),
    budget: 2500000,
    actualCost: 850000,
    createdBy: 'mock-user-1',
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-01-20'),
    stages: [
      {
        id: 0,
        name: 'Strategic Definition',
        description: 'Identifying client business case and strategic brief',
        status: 'completed',
        progress: 100,
        activities: [],
        approvals: [],
        informationExchanges: [
          {
            id: 'ie-1',
            name: 'Client Requirements Brief',
            description: 'Initial client requirements and project objectives',
            status: 'complete',
            requiredForSignoff: true,
            dateUploaded: new Date('2024-01-12')
          }
        ]
      },
      {
        id: 1,
        name: 'Preparation and Brief',
        description: 'Preparing project brief and initial proposals',
        status: 'completed',
        progress: 100,
        activities: [],
        approvals: [],
        informationExchanges: [
          {
            id: 'ie-2',
            name: 'Project Brief',
            description: 'Detailed project brief and design requirements',
            status: 'complete',
            requiredForSignoff: true,
            dateUploaded: new Date('2024-02-01')
          }
        ]
      },
      {
        id: 2,
        name: 'Concept Design',
        description: 'Preparing concept design and outline proposals',
        status: 'in-progress',
        progress: 65,
        activities: [],
        approvals: [],
        informationExchanges: [
          {
            id: 'ie-3',
            name: 'Concept Design Drawings',
            description: 'Initial concept design drawings and specifications',
            status: 'pending',
            requiredForSignoff: true
          }
        ]
      },
      {
        id: 3,
        name: 'Spatial Coordination',
        description: 'Coordinating spatial design and technical systems',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 4,
        name: 'Technical Design',
        description: 'Preparing technical design and specifications',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 5,
        name: 'Manufacturing and Construction',
        description: 'Manufacturing and construction phase',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 6,
        name: 'Handover',
        description: 'Project handover and completion',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 7,
        name: 'Use',
        description: 'In-use services and post-occupancy evaluation',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      }
    ],
    risks: [],
    team: []
  },
  {
    id: '2',
    name: 'Heritage Museum Renovation',
    description: 'Restoration and modernization of a Victorian-era museum',
    client: 'City Heritage Trust',
    referenceCode: 'HMR-2024-002',
    location: 'Historic Quarter, Leeds',
    status: 'active',
    currentStage: 1,
    startDate: new Date('2024-03-01'),
    targetCompletionDate: new Date('2024-12-15'),
    budget: 1200000,
    actualCost: 320000,
    createdBy: 'mock-user-1',
    createdAt: new Date('2024-02-15'),
    updatedAt: new Date('2024-03-05'),
    stages: [
      {
        id: 0,
        name: 'Strategic Definition',
        description: 'Identifying client business case and strategic brief',
        status: 'completed',
        progress: 100,
        activities: [],
        approvals: [],
        informationExchanges: [
          {
            id: 'ie-4',
            name: 'Heritage Assessment',
            description: 'Historical significance and conservation requirements',
            status: 'complete',
            requiredForSignoff: true,
            dateUploaded: new Date('2024-02-20')
          }
        ]
      },
      {
        id: 1,
        name: 'Preparation and Brief',
        description: 'Preparing project brief and initial proposals',
        status: 'in-progress',
        progress: 40,
        activities: [],
        approvals: [],
        informationExchanges: [
          {
            id: 'ie-5',
            name: 'Conservation Brief',
            description: 'Detailed conservation and renovation requirements',
            status: 'pending',
            requiredForSignoff: true
          }
        ]
      },
      {
        id: 2,
        name: 'Concept Design',
        description: 'Preparing concept design and outline proposals',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 3,
        name: 'Spatial Coordination',
        description: 'Coordinating spatial design and technical systems',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 4,
        name: 'Technical Design',
        description: 'Preparing technical design and specifications',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 5,
        name: 'Manufacturing and Construction',
        description: 'Manufacturing and construction phase',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 6,
        name: 'Handover',
        description: 'Project handover and completion',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 7,
        name: 'Use',
        description: 'In-use services and post-occupancy evaluation',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      }
    ],
    risks: [],
    team: []
  },
  {
    id: '3',
    name: 'Residential Housing Estate',
    description: '50 sustainable family homes with community facilities',
    client: 'Family Housing Association',
    referenceCode: 'RHE-2024-003',
    location: 'Suburbs, Birmingham',
    status: 'planning',
    currentStage: 0,
    startDate: new Date('2024-06-01'),
    targetCompletionDate: new Date('2026-03-30'),
    budget: 8500000,
    actualCost: 150000,
    createdBy: 'mock-user-1',
    createdAt: new Date('2024-05-01'),
    updatedAt: new Date('2024-05-15'),
    stages: [
      {
        id: 0,
        name: 'Strategic Definition',
        description: 'Identifying client business case and strategic brief',
        status: 'in-progress',
        progress: 25,
        activities: [],
        approvals: [],
        informationExchanges: [
          {
            id: 'ie-6',
            name: 'Site Analysis',
            description: 'Site survey and feasibility analysis',
            status: 'pending',
            requiredForSignoff: true
          }
        ]
      },
      {
        id: 1,
        name: 'Preparation and Brief',
        description: 'Preparing project brief and initial proposals',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 2,
        name: 'Concept Design',
        description: 'Preparing concept design and outline proposals',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 3,
        name: 'Spatial Coordination',
        description: 'Coordinating spatial design and technical systems',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 4,
        name: 'Technical Design',
        description: 'Preparing technical design and specifications',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 5,
        name: 'Manufacturing and Construction',
        description: 'Manufacturing and construction phase',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 6,
        name: 'Handover',
        description: 'Project handover and completion',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      },
      {
        id: 7,
        name: 'Use',
        description: 'In-use services and post-occupancy evaluation',
        status: 'not-started',
        progress: 0,
        activities: [],
        approvals: [],
        informationExchanges: []
      }
    ],
    risks: [],
    team: []
  }
];